import { useLocalization, cn } from '@magicdoorinc/ui';
import { createMemo } from 'solid-js';
import type { Component } from 'solid-js';
import type { PortalStatus } from '~/swagger/portal/Api';

export const TenantPortalStatus: Component<{ class?: string; status?: `${PortalStatus}` }> = (props) => {
  const { t } = useLocalization();
  const status = createMemo(() => {
    const map: Record<PortalStatus, { label: string; color: string }> = {
      active: { label: t('Active'), color: 'text-success' },
      invited: { label: t('Invited'), color: 'text-link' },
      notInvited: { label: t('Not invited'), color: 'text-warning' },
    };
    return props?.status && map[props.status];
  });
  return (
    <div class={cn('flex items-center gap-1 rounded-full bg-current-alpha px-2 py-0.5 text-xs', status()?.color, props.class)}>
      <i class="block size-1.5 rounded-full bg-current" />
      {status()?.label}
    </div>
  );
};
